<template>
  <section>
    <wrapper-preview-category>
      <div class="requests-buttons">
        <v-btn
          class="white__v-btn mr-3 "
          :class="{'blue__v-btn': 'Org' === orgType}"
          @click="changeOrgType('Org')">
          Данные организации
        </v-btn>
        <v-btn
          class="white__v-btn"
          :class="{'blue__v-btn': 'SubOrg' === orgType}"
          @click="changeOrgType('SubOrg')">
          Данные филиалов
        </v-btn>
      </div>
      
      <v-autocomplete
        :items="selectedOptions"
        v-model="selectedOption"
        class="mb-2"
      />
      
      <v-progress-linear
        indeterminate
        color="#00599b"
        v-if="loading"
      ></v-progress-linear>
      <CardOrgApplication
        v-for="item in selectedTypeApplication"
        :key="item.key"
        :item="item"
        :orgType="orgType"
        @reject="onReject($event)"
        @resolve="onResolve($event)"
        @aboutApplication="onClickAboutApplication($event)"
      />
      <div v-if="getActualApplicationsByOrgType.length === 0" class="text-center main-color font-size-large">
        Нет заявок
      </div>
    
    </wrapper-preview-category>
    <v-dialog v-model="modalOpen">
      <v-card>
        <v-card-text>
          <v-row dense class="my-2">
            <v-col>Поле</v-col>
            <v-col>Старое значение</v-col>
            <v-col>Новое значение</v-col>
          </v-row>
          <v-divider class="mb-2"/>
          <v-row dense v-for="row in selectedApplication" :key="row.field">
            <v-col cols="2">{{ row.field }}</v-col>
            <v-col>{{ row.oldValue }}</v-col>
            <v-col :class="{'application-type_UPDATE': row.changed}">{{ row.value }}</v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import CardOrgApplication from "@/components/cards/CardOrgApplication";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import AppealOrganizationController from "@/controllers/Organizations/AppealOrganizationController";
import AdminController from "@/controllers/AdminController";

export default {
  name: "OrgAppeals",
  components: {WrapperPreviewCategory, CardOrgApplication},
  data() {
    return {
      applications: [],
      applicationsNew: [],
      orgType: 'Org',
      modalOpen: false,
      loading: false,
      selectedApplication: [],
      selectedOptions: [
        {value: true, text: "Одобренные заявки"},
        {value: false, text: "Отклоненные заявки"},
        {value: null, text: "Не рассмотренные заявки"} //[true,false, null]
      ],
      selectedOption: null,
    };
  },
  mounted() {
    this.getActualApplications();
  },
  computed: {
    selectedTypeApplication() {
      return this.getActualApplicationsByOrgType.filter((el) => el.accept === this.selectedOption);
      
    },
    getActualApplicationsByOrgType() {
      if (this.orgType === "Org") {
        return this.applicationsNew.filter(item => item.appealType === "MAIN_ORG")
      } else if (this.orgType === "SubOrg") {//["FILIAL_ORG_UPDATE", 'FILIAL_ORG_CREATE', 'FILIAL_ORG_DELETE'].
        return this.applicationsNew.filter(item => item.appealType.includes('FILIAL'))
      } else return this.applicationsNew
    },
    
  },
  methods: {
    onClickAboutApplication(e) {
      console.log(e);
      if (this.orgType === 'SubOrg') {
        this.selectedApplication = e.dialogData.filter(el => el.field !== 'name')
      } else {
        this.selectedApplication = e.dialogData;
      }
      this.modalOpen = !this.modalOpen;
    },
    
    changeOrgType(type) {
      this.orgType = type
    },
    
    getActualApplications() {
      this.loading = true;
      AdminController.getOrgsAppeals(this.orgType)
        .then(data => this.applicationsNew = data)
        .finally(() => this.loading = false);
    },
    
    async onReject(e) {
      const item = this.applicationsNew.find(el => el.id === e);
      try {
        const res = await AppealOrganizationController.closeAppeal({id: e, accept: false});
        item.accept = res.accept;
        item.applicationStatus = AdminController.applicationStatusName(res.accept);
      } catch (e) {
        console.error(e);
      }
    },
    async onResolve(e) {
      const item = this.applicationsNew.find(el => el.id === e);
      try {
        const res = await AppealOrganizationController.closeAppeal({id: e, accept: true});
        item.accept = res.accept;
        item.applicationStatus = AdminController.applicationStatusName(res.accept);
      } catch (e) {
        console.error(e);
      }
    },
  }
}
</script>

<style scoped>

</style>